export default __webpack_public_path__ + "static/media/alogo.8dd7ed3e.webp";